import { registerDeprecationHandler, registerWarnHandler } from '@ember/debug';
import ENV from 'lumen/config/environment';

export function initialize() {
  registerDeprecationHandler((message, options, next) => {
    // Do not log deprecations when running tests
    if (ENV.environment === 'test') {
      return;
    }

    next(message, options);
  });

  registerWarnHandler((message, options, next) => {
    // Do not log ignored warnings when running tests
    const ignoredWarnings = ['binding-style-attributes'];
    if (
      ENV.environment === 'test' &&
      ignoredWarnings.some((warning) => message.includes(warning))
    ) {
      return;
    }

    next(message, options);
  });
}

export default {
  initialize,
};
